import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
// import ActionButton from '../action-button';
import ReactPaginate from 'react-paginate';
import { getAllDeHubProduct, changeDeHubProductStatus, deleteDeHubProduct } from '../../../api/apiService';
import { ToastError, ToastSuccess } from '../../../component/toast-notification';
import ActionButton from '../../../component/action-button';
import { Tooltip } from '@mui/material';
// import { ToastSuccess, ToastError } from "../../../toast-notification";

const ProductList = ({ pagInfo, foodPageFunc, hubId, categoryId = "", searchTerm = "" }) => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);

  const fetchProducts = async (page = 1, limit = 10) => {
    if (!hubId) return;

    setLoading(true);
    try {
      const response = await getAllDeHubProduct(page, limit, hubId, categoryId, searchTerm);
      setProducts(response.data.data || []);

      // Updated to work with the new data structure
      const pageInfo = response.data.pageInfo;
      setTotalPages(pageInfo?.totalPages || 1);
      setCurrentPage(pageInfo?.currentPage); // API returns 0-based page

      // if (response.data.msg) {
      //   ToastSuccess(response.data.msg);
      // }
    } catch (error) {
      console.error('Error fetching products:', error);
      ToastError(error.response?.data?.message || 'Failed to fetch products');
      setProducts([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProducts(currentPage);
  }, [hubId, categoryId, searchTerm]);

  const handlePageChange = ({ selected }) => {
    const newPage = selected + 1;
    fetchProducts(newPage);
    if (foodPageFunc) foodPageFunc({ selected });
  };
  const handleChangeDeHubProductStatus = async (e, product) => {
    e.preventDefault();
    try {
      const action = product.isActive ? "Inactive" : "Active";
      const confirmChange = window.confirm(`Are you sure you want to change the status to ${action}?`);
      if (!confirmChange) return;
      const response = await changeDeHubProductStatus(hubId, product._id);
      if (response?.data?.status === 200) {
        ToastSuccess(response.data.msg);
        fetchProducts();
      } else {
        ToastError(response?.data?.msg || "Failed to change product status");
      };
    } catch (error) {
      console.error("Error in delete De Hub Product: ", error);
      ToastError("Something went wrong");
    };
  };
  const handleDeleteDeHubProduct = async (e, productId) => {
    e.preventDefault();
    try {
      const confirmDelete = window.confirm(`Are you sure to delete this product. Once deleted cann't be undone?`);
      if (!confirmDelete) return;
      const response = await deleteDeHubProduct(hubId, productId);
      if (response?.data?.status === 200) {
        ToastSuccess(response.data.msg);
        fetchProducts();
      } else {
        ToastError(response?.data?.msg || "Failed to delete product");
      };
    } catch (error) {
      console.error("Error in delete De Hub Product: ", error);
      ToastError("Something went wrong");
    };
  };

  if (loading) return <div className="text-center">Loading...</div>;

  return (
    <>
      {products.length < 1 ? (
        <h2 className="text-center">No Products Available</h2>
      ) : (
        <div>
          <table className="table table-hover text-capitalize">
            <thead>
              <tr>
                <th>Image</th>
                <th>Product Name</th>
                <th>Category</th>
                <th>MRP</th>
                <th>Sell Price</th>
                <th>Buy Price</th>
                <th>Quantity</th>
                <th>Tax</th>
                <th>Min Order Qty</th>
                <th>Max Order Qty</th>
                <th>Packaging Charges</th>
                <th>Status</th>
                <th className="text-center">Action</th>
              </tr>
            </thead>
            <tbody>
              {products.map((item) => (
                <tr key={item._id}>
                  <td>
                    <img
                      src={item.images?.[0] || "/assate/images/food-logo.png"}
                      className="img-fluid table-img"
                      alt={item.product_name}
                      style={{ width: '50px', height: '50px', objectFit: 'cover' }}
                    />
                  </td>
                  <td>
                    <Link to={`/daily-essentials/hubs/single-hub/product-details?hubId=${item.hubId?._id}&productId=${item._id}`}>
                      {item.product_name}
                    </Link>
                  </td>
                  <td>
                    {item.categoryId?.name || 'N/A'}
                  </td>
                  <td>₹{item.mrp}</td>
                  <td>₹{item.sellPrice}</td>
                  <td>₹{item.buyPrice}</td>
                  <td>{item.qty} <span className='text-bold'></span> {item.unit}</td>
                  {/* <td>{item.qty} <span className='text-bold'>&#10006;</span> {item.unit}</td> */}
                  <td>{item.tax}%</td>
                  <td>{item.minOrderQty}</td>
                  <td>{item.maxOrderQty}</td>
                  <td>₹{item.packagingCharge}</td>
                  <td>
                    <span
                      className={`cursor-pointer badge ${item.isActive ? "badge-success" : "badge-danger"}`}
                      onClick={(e) => handleChangeDeHubProductStatus(e, item)}
                    >
                      {item.isActive ? "Active" : "Inactive"}
                    </span>
                  </td>
                  <td>
                    <span className="user-table-auction-item">
                      <>
                        <Tooltip title="Update" arrow>
                          <Link to={`/daily-essentials/hubs/single-hub/product-from?hubId=${item.hubId?._id}&productId=${item._id}`}>
                            <ActionButton>
                              <i className="demo-icon icon-edit">&#xe80f;</i>
                            </ActionButton>
                          </Link>
                        </Tooltip>
                        <Tooltip title="Delete" arrow>
                          <span onClick={(e) => handleDeleteDeHubProduct(e, item._id)}>
                            <ActionButton >
                              <i className="demo-icon icon-delete">&#128465;</i>
                            </ActionButton>
                          </span>
                        </Tooltip>
                      </>
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          <ReactPaginate
            previousLabel={'<<'}
            nextLabel={'>>'}
            breakLabel={'...'}
            breakClassName={'break-me'}
            marginPagesDisplayed={2}
            pageRangeDisplayed={2}
            pageCount={totalPages}
            onPageChange={handlePageChange}
            containerClassName={'pagination'}
            activeClassName={'active'}
            forcePage={currentPage - 1}
          />
        </div >
      )}
    </>
  );
};

export default ProductList;